import linkApi from "../../../api/linkApi";
import * as messages from "../../../constants/ToastrConstants";
import { showToastrError, showToastrSuccess, showToastrWarning, showToastrInfo } from "../../../util/toastr";
import assign from 'object-assign';
import mergeDeep from "../../../util/mergeDeep";
import { ValidationMessageTypes } from "../../../constants/ComponentConstants";
import { RelatieTypesEnum, UserTypes } from "../../../constants/DomainConstants";

export default class LinkOverzichtPageHelper {
	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;
		const transactieId = params.transactieId;
		const isNew = context.props.isNew;

		ajaxActions.started();

		linkApi.getLinksBySportclub(transactieId, isNew)
			.then((response) => {
				ajaxActions.ended();
				this.processModel(response.data, false);
			})
			.catch((ex) => {
				ajaxActions.failed();
				if (ex.response.status === 404) {
					showToastrError(messages.MESSAGE_NO_VALID_TRANSACTION_FOUND);
					context.setState({ hasUnsavedChanges: false });
					this.redirector.goTo("/federatie/overzicht");
				}
				else {
					context.props.throwException(ex, true);
				}
			});
	}

	processModel(response, hasUnsavedChanges) {
		const context = this.context;
		const models = response.model.bovenliggendeRelaties.map(x => mergeDeep({ checked: true }, x));
		const originalModels = assign([], models.map(x => mergeDeep({}, x)));
        const {showLinkChecks, lidVanSportraad, erkendDoorSportdienst, gesubsidieerdDoorOverheidsinst} = response.model;

        const checkboxStatussen = {
            showLidVanSportraad: showLinkChecks && !lidVanSportraad,
            showErkendDoor: showLinkChecks && !erkendDoorSportdienst,
            showGesubsidieerdDoor: showLinkChecks && !gesubsidieerdDoorOverheidsinst,
            lidVanSportraad,
            erkendDoorSportdienst,
            gesubsidieerdDoorOverheidsinst,
            originalLidVanSportraad: lidVanSportraad,
            originalErkendDoorSportdienst: erkendDoorSportdienst,
            originalGesubsidieerdDoorOverheidsinst: gesubsidieerdDoorOverheidsinst
    };
		const tabSettings = response.tabSettings;
		context.props.setTabSettings(tabSettings);

		context.setState({
			models,
			originalModels,
			hasUnsavedChanges: hasUnsavedChanges,
			identificatieCodeChanged: false,
			undoButtonDisabled: true,
			checkboxStatussen,
            showLinkChecks
		});
	}

	onChangeOverzichtCheckbox = (event) => {
		const value = event.target.checked;
		const id = event.target.name.split('_')[1];
		const relatieType = event.target.name.split('_')[2];
		const models = this.context.state.models.map(x => mergeDeep({}, x));

		if (models && models.length > 0) {
			models.find(x => x.id == id && x.relatieType == relatieType).checked = value;
		}

		if(relatieType === RelatieTypesEnum.ERKEND_DOOR){
			const erkendDoor = models.find(x => x.id === id && x.relatieType.toString() === RelatieTypesEnum.GESUBSIDIEERD_DOOR);
			if(erkendDoor)
				erkendDoor.checked = value;
		}



		this.context.setState({
			models,
			hasUnsavedChanges: true,
			undoButtonDisabled: false
		});
	};

	onChangeLinksCheck = (event) => {
		const value = event.target.checked;
        const name = event.target.name;

        const checkboxStatussen = mergeDeep({},this.context.state.checkboxStatussen);

        checkboxStatussen[name] = value;
		this.context.setState({
			checkboxStatussen
		});
	};

	undo() {
		const context = this.context;
		const state = this.context.state;
		let models = assign([], state.originalModels);

		context.setState({
			models,
			undoButtonDisabled: true,
			hasUnsavedChanges: false
		});
	}

	add() {
		this.context.setState({
			addMode: true,
			searchModels: [],
			typeFilter: 1,
			naamFilter: "",
			sporttakFilter: null,
			errors: [],
			naamFilterHasFocus: true
		});
		this.context.props.disableNav();
	}

	handleOnEditIdentificatieCode(organisatieId) {
		let organisatieToEdit = mergeDeep({}, this.context.state.models.find(x => x.id === organisatieId));

		this.context.setState({
			editMode: true,
			editingOrganisatie: organisatieToEdit
		});
	
		this.context.props.disableNav();
	}


	
	cancelAdd() {
		this.context.setState({
			relatieType: -1,
			addMode: false,
			searchModels: [],
			typeFilter: 1,
			naamFilter: "",
			sporttakFilter: null,
			errors: [],
			naamFilterHasFocus: true,
		});

		this.context.props.enableNav();
	}

	cancelEdit(){
		this.context.setState({
			editMode: false,
			editingOrganisatie: undefined
		});

		this.context.props.enableNav();
	}
	continueEdit(){
		
		var modelsWithoutEditmodel = this.context.state.models.filter(x => x.id !== this.context.state.editingOrganisatie.id);

		this.context.setState({
			editMode: false,
			models: modelsWithoutEditmodel.concat(this.context.state.editingOrganisatie),
			identificatieCodeChanged: true
		});

		this.context.props.enableNav();
	}

	continueAdd() {
		let undoButtonDisabled = this.context.state.undoButtonDisabled;
		let models = this.context.state.models.map(x => mergeDeep({}, x));
		this.context.state.searchModels.filter(e => e.checked).forEach((item) => {
			undoButtonDisabled = false;
			models.push({
				afkorting: item.afkorting,
				id: item.id,
				naam: item.naam,
				type: item.type,
				relatieType: this.context.state.relatieType,
				identificatieCode: item.identificatieCode,
				sporttakken: item.sporttakken,
				checked: true
			});
		});

		this.context.setState({
			addMode: false,
			models: assign([], models.map(x => mergeDeep({}, x))),
			hasUnsavedChanges: true,
			undoButtonDisabled: undoButtonDisabled
		});

		this.context.props.enableNav();
	}

	changeAddFilter(event) {
		const property = event.target.name;
		const value = event.target.value;

		this.context.setState({
			[property]: value,
			naamFilterHasFocus: this.context.state.relatieType === -1
		});
	}

	
	changeIdentificatieCode(event) {
		const property = event.target.name;
		const value = event.target.value;

		var editingOrg = this.context.state.editingOrganisatie;

		editingOrg[property] = value;
		this.context.setState({
			editingOrganisatie: editingOrg,
			hasUnsavedChanges: true,
		});
	}

	changeToAdd(event) {
		const property = event.target.name;
		const value = event.target.checked;

		let searchModels = this.context.state.searchModels;
		searchModels.find(e => e.id === property).checked = value;

		this.context.setState({
			searchModels
		});
	}

	save() {
		if (!this.context.state.showLinkChecks || this.context.state.identificatieCodeChanged || this.context.props.userType == UserTypes.WEBSITEBEZOEKER) {
			this.saveLinks();
		} else {
			this.saveLinkChecks();
		}
	}

	saveLinks(){
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;
		const transactieId = params.transactieId;

		let errors = null;
		let model = null;

		const modelToSave = {
			transactionId: transactieId,
			model: {
				id: context.state.sportclubId,
				identificatieCode: context.state.models.find(x => x.id == context.props.federatieId)?.identificatieCode,
				bovenliggendeRelaties: context.state.models.filter(x => x.checked)
			}
		};

		ajaxActions.started();
		return linkApi.save(modelToSave).then((response) => {
			ajaxActions.ended();
			let hasUnsavedChanges = this.context.hasUnsavedChanges;
			let validationMessageType;
			if (response.statusText === "OK" && !response.data.hasValidationErrors) {
				if (Object.keys(response.data.validationResults).length !== 0) {
					model = assign({}, response.data.item);
					errors = assign({}, response.data.validationResults);
					showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS);
					showToastrSuccess(messages.MESSAGE_SAVED);
				}
				else {
					model = assign({}, response.data.item, {});
					errors = {};
					showToastrSuccess(messages.MESSAGE_SAVED);
				}
				hasUnsavedChanges = false;
				validationMessageType = ValidationMessageTypes.WARNING;
				this.processModel(model, hasUnsavedChanges);
			} else {
				errors = assign({}, response.data.validationResults);
				model = assign({}, response.data.item, {});
				showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
				validationMessageType = ValidationMessageTypes.ERROR;
				this.context.setState({
					errors,
					validationMessageType,
					shouldScrollToFirstError: true
				});
			}
		})
			.catch((ex) => {
				ajaxActions.failed();
				if (ex.response.status === 404) {
					showToastrError(messages.MESSAGE_NO_VALID_TRANSACTION_FOUND);
					context.setState({ hasUnsavedChanges: false });
					context.props.setHasUnsavedChanges(false);
					this.redirector.goTo("/federatie/overzicht");
				}
				else {
					context.props.throwException(ex, true);
				}
			});
	}

	saveLinkChecks(){
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;
		const transactieId = params.transactieId;
		const state = context.state;
		const isNew = context.props.isNew;
        const checkboxStatussen = state.checkboxStatussen;

		if (state.showLinkChecks) {
			ajaxActions.started();
			return linkApi.saveLinkChecks(transactieId, checkboxStatussen, isNew).then((response) => {
				ajaxActions.ended();
				this.processModel(response.data, false);
				})
				.catch((ex) => {
					ajaxActions.failed();
					context.props.throwException(ex);
				});
		}
	}

	search() {
		const context = this.context;
		const state = context.state;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;
		const transactieId = params.transactieId;

		const filter = {
			type: state.typeFilter,
			naam: state.naamFilter,
			sporttak: state.sporttakFilter
		};

		ajaxActions.started();
		linkApi.listOrganisatiesByFilter(filter, transactieId)
			.then((response) => {
				ajaxActions.ended();
				if (response.data.item.results.length === 0) {
					showToastrError("Geen links / relaties gevonden die voldoen aan de opgegeven zoekcriteria.");
				}
				if (response.data.item.results.length >= 100) {
					showToastrInfo("Gelieve je zoekopdracht te verfijnen.");
				}
				this.context.setState({
					searchModels: response.data.item.results || [],
					errors: response.data.validationResults || []
				});
			})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}
}
